module.exports = __webpack_public_path__ + "static/media/server-dashboard.daf5027f.png";